import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResize = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 9.733,
	height: 9.73,
	viewBox: "0 0 9.733 9.73",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		"data-name": "Icon - Resize",
		transform: "translate(-1.345 -1.348)",
		children: /* @__PURE__ */ _jsxs("g", {
			"data-name": "Group 4728",
			transform: "translate(1 1)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 7554",
					d: "M4.7.752H.75V4.7",
					transform: "translate(0.345 0.346)",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "Path 7555",
					d: "M5.056,9H9V5.056",
					transform: "translate(0.329 0.329)",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("line", {
					"data-name": "Line 1584",
					x2: 7,
					y2: 7,
					transform: "translate(1.712 1.712)",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5
				})
			]
		})
	})
});
export { SvgResize as ReactComponent };
